<template lang="pug">
  #GameRestarting
    game-header
    .container
      .px-5
        h1.title 🛠️ Getting things in order
        p Just putting some things in order, soon you'll be all ready to start painting again!
</template>

<script>
import GameHeader from './GameHeader'

export default {
  name: 'GameRestarting',
  components: {
    GameHeader
  }
}
</script>

<style lang="scss">

</style>
